// extracted by mini-css-extract-plugin
export default {"tableNoContent":"Table_tableNoContent__hMS7u","text":"Table_text__NE6Zf"};